import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBWV-a7fhqe3t5FwUBIvfxMfTyQjdK0RjI",
  authDomain: "robot-race-website.firebaseapp.com",
  projectId: "robot-race-website",
  storageBucket: "robot-race-website.firebasestorage.app",
  messagingSenderId: "287837239929",
  appId: "1:287837239929:web:d55a8aaf635f09148cf2a8",
  measurementId: "G-E41YJKQH40"
};

// Initialize Firebase
// ✅ Initialize app only once
const app = initializeApp(firebaseConfig);

// ✅ Initialize analytics (optional)
const analytics = getAnalytics(app);

// ✅ Initialize Firestore
export const db = getFirestore(app);

export { app, analytics };